import React from 'react';
import { textTransformer } from '../../utils';
import { TableComponentsProps } from '../table-components.props';

export const RecommendedMileage = ({ row }: TableComponentsProps): JSX.Element=> {
  const mileageRecommendation = row && row.uds_mileagerecommendation;

  return (
    <span>
      {mileageRecommendation ? textTransformer(' ', 'end', 2, true, mileageRecommendation) : '-'}
    </span>
  );
};
